import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../utils/axiosAuth";

export const fetchPOSComboItems = createAsyncThunk(
  "api/POSComboItems/fetch",
  async (_, thunkAPI) => {
    try {
      const response = await api.get(`/api/POSComboItems`);
      return { rows: response.data || [] };
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

const POSComboItemsSlice = createSlice({
  name: "POSComboItems",
  initialState: { rows: [], status: "idle", error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPOSComboItems.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchPOSComboItems.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.rows = action.payload.rows;
      })
      .addCase(fetchPOSComboItems.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "حدث خطأ غير متوقع";
      });
  },
});

export default POSComboItemsSlice.reducer;
export const selectPOSComboItemsRows = (state) => state.POSComboItems.rows;
export const selectPOSComboItemsStatus = (state) => state.POSComboItems.status;
export const selectPOSComboItemsError = (state) => state.POSComboItems.error;
